import React from "react";
import { Img, useRemotionEnvironment } from "remotion";

/**
 * 🛡 씬/콘텐츠 이미지 — 크래시 내성 래퍼(회장님 2026-07-22 "썸네일·미리보기 통째 먹통").
 *
 * 맨 Remotion `<Img>` 는 이미지 로드 실패 시 maxRetries(기본 2) 후 `cancelRender('Error loading image…')` 로
 * **컴포지션 전체를 크래시**시킨다(node_modules/remotion Img.js 실측). 갤러리 썸네일(`<Thumbnail>`)·미리보기
 * (`<Player>`)에선 이미지 하나만 삐끗해도(생성 직후 전파 지연·순간 네트워크 실패 등 TOCTOU) 그 컷이 아니라
 * **컴포지션 전체가 검정으로 죽고 재마운트 전까지 고착**된다.
 *
 * 그래서 프리뷰/썸네일(비 렌더)에선 순수 `<img>` 로 그린다 — 로드 실패해도 브라우저가 깨진 아이콘만 표시하고
 * React/Remotion throw·delayRender 게이트가 없어 컴포지션이 죽지 않는다(그 컷만 빔). 실제 MP4 렌더
 * (renderMediaOnWeb=`isClientSideRendering` / 서버 렌더=`isRendering`)에선 종전대로 `<Img>` 로 프레임 로드
 * 게이팅을 유지한다(빈 프레임 방지). ★게이트는 각 템플릿의 AudioTag(`isRendering||isClientSideRendering`) 와 동일★.
 */
export const SceneImg: React.FC<React.ComponentPropsWithoutRef<typeof Img>> = (props) => {
  const env = useRemotionEnvironment();
  if (env.isRendering || env.isClientSideRendering) return <Img {...props} />;
  // 프리뷰/썸네일: Remotion 전용 prop(순수 <img> 속성 아님)은 제거해 DOM 경고 방지. onError/crossOrigin/src/style 등은 통과.
  const {
    pauseWhenLoading: _pauseWhenLoading,
    delayRenderRetries: _delayRenderRetries,
    delayRenderTimeoutInMilliseconds: _delayRenderTimeoutInMilliseconds,
    onImageFrame: _onImageFrame,
    maxRetries: _maxRetries,
    ...imgProps
  } = props;
  return <img {...(imgProps as React.ImgHTMLAttributes<HTMLImageElement>)} alt={imgProps.alt ?? ""} />;
};
